export default __webpack_public_path__ + "assets/png/ef1bc3c1ae6a594b9c53e6441e217e4e.png";